import { Button, ButtonProps, ThemeIcon, createPolymorphicComponent } from "@mantine/core"
import styled from '@emotion/styled'
import { NavLink } from "react-router-dom"
import { Icon } from '@iconify/react'
import { IconNames } from "src/components/ui/Icons"

type SideBarNavButtonProps = {
    to: string
    label: string
    icon: IconNames | string;
    onClick?(): void
}

const _StyledButton = styled(Button)`
    & .mantine-Button-inner {
        justify-content: flex-start;
    }        
    &.active {        
        [data-mantine-color-scheme='light'] & {
            background-color: var(--mantine-color-gray-3);
        }
        [data-mantine-color-scheme='dark'] & {
            background-color: var(--mantine-color-dark-9);
        }
    }    
    
`
const StyledButton = createPolymorphicComponent<'button', ButtonProps>(_StyledButton);

export const SideBarNavButton: React.FC<SideBarNavButtonProps> = ({ to, label, icon, onClick }) => {
    return (
        <StyledButton
            variant="subtle"
            color="text-primary"
            to={to}
            component={NavLink}
            size="lg"
            leftSection={<ThemeIcon color="dark" variant="outline" size="lg"><Icon icon={icon} width="20" color={`var(--mantine-color-brand-5)`} /></ThemeIcon>}
            onClick={onClick}
        >
            {label}
        </StyledButton>
    )
}